var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{
    select_boxes: !_vm.scrollable,
    'select_boxes--scrollable': _vm.scrollable
  }},_vm._l((_vm.items),function(item){return _c('SelectBox',{key:item.name,ref:item.value,refInFor:true,attrs:{"is-out-of-stock":item.is_out_of_stock,"label":item.name,"value":item.value,"is-selected":item.value === _vm.selectedValue},on:{"input":_vm.selectRadioBtn}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }